import React from "react";
import Prices from "../components/Prices";
import "./Pricing.css";
import ProductTryout from "../components/ProductTryout";
import NavLight from "../components/NavLight";
import {meta} from "../assets/meta/meta";
import {CustomMetaHelmet} from "../components/CustomMetaHelmet";

function Pricing() {
    return (
        <main className="Pricing">
            <CustomMetaHelmet meta={meta.pricing}/>
            <NavLight/>
            <section className="pricing-container">
                <div className="pricing-content">
                    <h1>Simple, transparent pricing</h1>
                    <p>Try it for free and see what works best for you.</p>
                </div>
                <Prices/>
                <div className="pricing-content">
                    <p style={{width: '100%', fontSize: '16px'}}>
                        One piece of feedback is equal to one support ticket, online review, document or survey submission.
                    </p>
                </div>
            </section>
            {/* <section className="plan-comparison">
                <section className="plan-container">
                    <h1>Compare Plans</h1>
                    <ProductComparison />
                </section>
            </section> */}
            <section>
                <ProductTryout/>
            </section>
        </main>
    );
}

export default Pricing;
